export default {
      id: "onesite-logo-usage",
      viewBox: "0 0 560 120",
      url: __webpack_public_path__ + "sprite.svg#onesite-logo",
      toString: function () {
        return this.url;
      }
    }